import { ApiResponse, TokenData, Log, PaginatedApiResponse } from '../models';
import * as http from './http';
import ApiService from './service';
import { stringify } from 'querystring';
import { Dict } from '../../models';

export class LogService extends ApiService {
  public async getAllLogs(
    data: {
      page: number;
      leadId?: string;
    } & Dict
  ): Promise<PaginatedApiResponse<Log>> {
    const url = `${this.apiDomain}/api/system-logs?${stringify(data)}`;

    const resposne = await http.get<PaginatedApiResponse<Log>>(url, this.store);
    return { ...resposne.data };
  }

  public async getLog(logID?: string) {
    const url = `${this.apiDomain}/api/system-logs/${logID}`;

    const response = await http.get<ApiResponse<Log>>(url, this.store);
    return response.data;
  }

  public async getBackgroundJob(logID?: string) {
    const url = `${this.apiDomain}/api/system-logs/background-job/${logID}`;

    const response = await http.get<ApiResponse<any>>(url, this.store);
    return response.data?.data;
  }
}
